
























































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { SingleRecordDetailsInterface } from '@/interfaces/SingleRecordDetailsInterface';

@Component
export default class TechnologyFinite extends Vue {
    @Prop({ required: true })
    protected singleRecordData!: SingleRecordDetailsInterface;
    @Prop({ required: true }) protected normalizeData!: (
        property: string | number | null,
    ) => string | number;
}
